import React, { ReactNode } from "react";
import { Box, Link as MuiLink, Typography } from "@mui/material";

type Props = {
	text: ReactNode;
};

export function Title({ text }: Props) {
	return (
		<Box
			sx={{
				color: "primary.contrastText",
				backgroundColor: "primary.main",
				padding: "0 1rem",
			}}
		>
			<Typography
				sx={{
					fontWeight: "bolder",
					fontStyle: "italic",
					textAlign: "left",
				}}
			>
				{text}
			</Typography>
		</Box>
	);
}

export function Caption({ text }: Props) {
	return (
		<Box
			sx={{
				fontSize: "smaller",
				fontWeight: "lighter",
				fontStyle: "italic",
				textAlign: "left",
			}}
		>
			{text}
		</Box>
	);
}

type PropsLink = Props & {
	href: string;
};

export function Link({ text, href }: PropsLink) {
	return (
		<MuiLink sx={{ fontWeight: "bold", cursor: "pointer !important" }} color={"#00a6ff"} href={href} target="_blank">
			{text}
		</MuiLink>
	);
}
